<template>
  <div>

    <div v-if="isAuth">
      <form @submit.prevent="onSubmit">
        <form-group class="my-4" :validations="$v.form.rate">
          <div slot-scope="{ errors, invalid }">
            <div class="star-rating">
              <input type="radio" name="stars" v-model="form.rate" id="star-a" value="5"/>
              <label for="star-a"></label>

              <input type="radio" name="stars" v-model="form.rate" id="star-b" value="4"/>
              <label for="star-b"></label>

              <input type="radio" name="stars" v-model="form.rate" id="star-c" value="3"/>
              <label for="star-c"></label>

              <input type="radio" name="stars" v-model="form.rate" id="star-d" value="2"/>
              <label for="star-d"></label>

              <input type="radio" name="stars" v-model="form.rate" id="star-e" value="1"/>
              <label for="star-e"></label>
            </div>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>


        <form-group :validations="$v.form.body">
          <div slot-scope="{ errors, invalid }">
            <b-form-textarea v-model="form.body"/>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <b-button class="mt-3" pill type="submit">ثبت</b-button>

      </form>
    </div>

    <div v-else>
      <b-col lg="12" class="text-center my-5">
        <m-a  :href="{name:'Login'}">
          برای ثبت نظر وارد شوید.
        </m-a>
      </b-col>
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {required} from "vuelidate/lib/validators";
import FormGroup from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormGroup";
import FormErrorsManager
  from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormErrorsManager";

export default {
  name: "CommentForm1",
  components: {FormGroup, FormErrorsManager,},
  props: {
    commentable_id: {},
    commentable_type: {}
  },
  computed: {
    ...mapGetters({
      isAuth: "User/isAuthenticated"
    })
  },
  data() {
    return {
      form: {
        body: '',
        rate: ''
      }
    }
  },
  validations: {
    form: {
      body: {},
      rate: {required},
    },
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        const form = {...this.form, commentable_id: this.commentable_id, commentable_type: this.commentable_type}
        this.$store.dispatch("Comment/createComment", form)
      }
    },
  }
}
</script>

<style scoped>

/* use reverse flexbox to take advantage of flex-direction: reverse */
.star-rating {
  display: flex;
  align-items: center;
  width: 160px;
  flex-direction: row-reverse;
  justify-content: space-between;
  position: relative;
}

/* hide the inputs */
.star-rating input {
  display: none;
}

/* set properties of all labels */
.star-rating > label {
  width: 30px;
  height: 30px;
  font-size: 30px;
  transition: 0.2s ease;
  color: orange;
}

/* give label a hover state */
.star-rating label:hover {
  color: #ff69b4;
  transition: 0.2s ease;
}

.star-rating label:active::before {
  transform: scale(1.1);
}

/* set shape of unselected label */
.star-rating label::before {
  content: '\2606';
  position: absolute;
  top: 0px;
}

/* set full star shape for checked label and those that come after it */
.star-rating input:checked ~ label:before {
  content: '\2605';
}

@-moz-document url-prefix() {
  .star-rating input:checked ~ label:before {
    font-size: 36px;
    line-height: 21px;
  }
}

</style>